<template>
  <div class="amendSpecificationDialogBox">
    <el-dialog center :title="data.title ? data.title : '修改规格'" :visible="amendSpecificationDialog"
      @close="amendSpecificationDialogClose">
      <el-form :model="form" label-position="left" label-width="110px">
        <!-- <el-form-item label="规格">
          <el-cascader v-model="specificationIdArr" :options="specificationOptions" @change="specificationChange"
            ref="specificationRef"></el-cascader>
        </el-form-item> -->
        <el-form-item :label="(data.title == '修改规格'?(data.item?.productManageDTO?.firstCategoryId == 2):(data.item?.firstCategoryId == 2)) ? (data.title == '修改规格'?(data.item?.productManageDTO?.serviceSpecificationOne || '--'):(data.item?.serviceSpecificationOne || '--')) : '规格'">
          <el-select v-model="specificationsModel" @change="specificationsChange" placeholder="请选择">
            <el-option v-for="item in specificationOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="specificationsTwoShow" :label="(data.title == '修改规格'?(data.item?.productManageDTO?.firstCategoryId == 2):(data.item?.firstCategoryId == 2)) ? (data.title == '修改规格'?(data.item?.productManageDTO?.serviceSpecificationTwo || '--'):(data.item?.serviceSpecificationTwo || '--')) : '产品'">
          <el-select v-model="form.specificationsTwo" placeholder="请选择">
            <el-option v-for="item in specificationsTwoOptions" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="form.quantity" :min="1" :max="10" label="描述文字"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="noBtn" @click="amendSpecificationDialogClose">取 消</el-button>
        <el-button class="subBtn" type="primary" @click="subBtnClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { transformSpecData } from '@/utils/cascaderAdapter'; //修改二级数据用于el-cascader多级不同字段
export default {
  props: ["amendSpecificationDialog", "data"],
  data() {
    return {
      form: {
        quantity: "1",
        specification: "",
        specificationsTwo: "",
      },

      specificationOptions: [],  //下拉列表数据
      specificationIdArr: [],  // 存储选中的 value 路径

      specificationsModel: '', //一级规格
      specificationsTwoOptions: [], //二级规格集合
      specificationsTwoShow: false, //二级规格是否显示

      firstLevelIsTrue: false, //规格一级数量是否大于1， 默认false不等于1,true是小于等于1
    };
  },
  mounted() {
  },

  methods: {
    // 规格变更处理
    specificationChange(value) {
      this.form.specification = value[0];
      this.form.specificationsTwo = value[1];
      console.log(this.form)

      // console.log('选中的 value 路径:', value) // 例如 ['3', '234']

      // 获取完整节点信息（包含原始数据）  暂时不需要
      // const checkedNodes = this.$refs.specificationRef.getCheckedNodes()
      // if (checkedNodes && checkedNodes.length) {
      //   const lastNode = checkedNodes[0]
      //   // 获取路径上所有节点（Element UI 内部有 pathNodes，如果没有可自己递归）
      //   const pathNodes = lastNode.pathNodes || this.getPathNodes(lastNode)
      //   // 一级节点原始数据
      //   const firstLevelOriginal = pathNodes[0]?.data?.original
      //   console.log('一级原始数据:', firstLevelOriginal)
      //   console.log('一级 itemCode:', firstLevelOriginal?.itemCode)
      //   console.log('一级 name:', firstLevelOriginal?.name)
      //   // 二级节点原始数据
      //   const secondLevelOriginal = pathNodes[1]?.data?.original
      //   console.log('二级原始数据:', secondLevelOriginal)
      //   console.log('二级 productCode:', secondLevelOriginal?.productCode)
      // }
    },

    // 一级规格选择
    specificationsChange(val) {
      const selectedItem = this.specificationOptions.find(item => item.value === val);
      console.log(selectedItem.children)
      this.form.specification = val;
      this.specificationsTwoOptions = selectedItem.children;
      this.form.specificationsTwo = '';

      if (selectedItem.children.length == 1 && selectedItem.children[0].label == '') {
        this.specificationsTwoShow = false;
        this.form.specificationsTwo = selectedItem.children[0].value;
      } else {
        this.specificationsTwoShow = true;
      }
    },

    // 获取父组件传递过来的数据
    receiveData(data) {
      console.log(data)
      if (data.title == '修改规格') {
        // 20260521注释规格二级联动开始
        // this.specificationIdArr = [];
        // this.specificationIdArr.push(data.item.specifications);
        // this.specificationIdArr.push(data.item.specificationsTwo);
        // 20260521注释规格二级联动结束

        this.specificationOptions = transformSpecData(data.item.productManageDTO.specifications, data.item.productManageDTO.firstCategoryId)

        this.specificationsModel = data.item.specifications;
        this.form.specification = data.item.specifications;
        const selectedItem = this.specificationOptions.find(item => item.value === data.item.specifications);
        this.specificationsTwoOptions = selectedItem.children;
        if (selectedItem.children.length == 1 && selectedItem.children[0].label == '') {
          this.specificationsTwoShow = false;
        } else {
          this.specificationsTwoShow = true;
        }
        this.form.specificationsTwo = data.item.specificationsTwo;
      } else {
        this.specificationOptions = transformSpecData(data.item.specifications, data.item.firstCategoryId)
      }
    },

    // 关闭弹窗
    amendSpecificationDialogClose() {
      // 点击遮罩或按 ESC 关闭时，el-dialog 已自动发出 update 事件，此处可留空或做清理
      this.$emit("close");
      this.specificationsModel = '';
      this.specificationsTwoOptions = [];
      this.form.specificationsTwo = '';
      this.form.quantity = "1";
      this.specificationsTwoShow = false;
    },

    // 确认按钮点击处理
    subBtnClick() {
      console.log(this.form.specification)
      console.log(this.form.specificationsTwo)
      if (this.form.specification && this.form.specificationsTwo) {
        this.$emit('amendSpecificationSubData', this.form);
        this.form = {
          quantity: "1",
          specification: "",
          specificationsTwo: "",
        }
        this.specificationIdArr = [];
        this.specificationsModel = '';
        this.specificationsTwoOptions = [];
        this.specificationsTwoShow = false;
      } else {
        this.$message.error('请选择规格')
        return
      }
    },
  },
};
</script>

<style scoped>
.amendSpecificationDialogBox ::v-deep .el-dialog {
  border-radius: 8px;
}

.amendSpecificationDialogBox ::v-deep .el-dialog__header {
  background-color: #a4b0d0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 14px 20px;
}

.amendSpecificationDialogBox ::v-deep .el-dialog__title {
  color: #fff;
}

.amendSpecificationDialogBox ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.amendSpecificationDialogBox ::v-deep .el-form-item {
  border-bottom: 1px solid #d9d9d9;
  padding: 15px 20px;
  margin-bottom: 0;
}

.amendSpecificationDialogBox ::v-deep .el-dialog--center .el-dialog__body {
  padding: 0;
}

.amendSpecificationDialogBox ::v-deep .el-form-item__content {
  display: flex;
}

.amendSpecificationDialogBox ::v-deep .el-select {
  flex: 1;
}

.amendSpecificationDialogBox ::v-deep .el-cascader {
  flex: 1;
}

.amendSpecificationDialogBox .subBtn {
  padding: 12px 50px;
  background: linear-gradient(90deg,
      rgba(0, 95, 196, 1) 0%,
      rgba(88, 161, 255, 1) 100%);
}

.amendSpecificationDialogBox .noBtn {
  padding: 12px 50px;
  border: 1px solid #7fc5ea;
  color: #008cd6;
}

.amendSpecificationDialogBox ::v-deep .el-input__inner,
.amendSpecificationDialogBox ::v-deep .codebtn,
.amendSpecificationDialogBox ::v-deep .el-form-item__label {
  height: 40px;
  line-height: 40px;
}

/* 适配手机端 */
@media only screen and (max-width: 1024px) {}

@media only screen and (max-width: 767px) {
  .amendSpecificationDialogBox ::v-deep .el-dialog {
    width: 94%;
    margin-top: 8vh !important;
  }

  .amendSpecificationDialogBox ::v-deep .el-dialog__footer {
    padding: 10px 10px 20px;
  }
}
</style>
